<template>
    <div class="product-qrcode">
        <canvas id="productQrcode" width="85" height="85"></canvas>
        <p :style="{ color: textColor }">微信扫码查看</p>
    </div>
</template>

<script>
import UQRCode from 'uqrcodejs';
import {CompService} from '@/service'

export default {
    props: {
        compID: { default: 0 },
        compLogo: { default: '' },
        textColor: { default: '#ffffff' }
    },
    data() {
        this.qr = null;
        return {

        }
    },
    mounted() {
        this.initQrCode();
    },
    methods: {
        initQrCode() {
            this.qr = new UQRCode();
            this.qr.data = `https://big-engineer.global-dsc.cn/product-list?compId=${this.compID}`;
            this.qr.size = 85;
            const option = {
                margin: 3,
            };

            this.qr.setOptions(option);
			this.qr.make();
            const canvas = document.getElementById("productQrcode");
            const canvasContext = canvas.getContext("2d");
            this.qr.canvasContext = canvasContext;
            const ctx = this.qr.canvasContext;
            this.qr.drawCanvas();

            if (this.compLogo) {
                const image = new Image();
                image.src = CompService.getCompLogo(this.compLogo);
                image.onload = function () {
                    ctx.drawImage(this, 32.5, 34.5, 20, 16)
                }
            }
        }
    },
}
</script>

<style scoped lang="less">
.product-qrcode{
    width: 85px;
    p{
        font-size: 12px;
        margin: 0;
        padding: 0;
        line-height: 15px;
        text-align: center;
    }
}
</style>
